import React from 'react';
import PropTypes from 'prop-types';

import './_contact.scss';

const Contact = props => (
  <section id="contact">
    <div id="title">
      <h2>Get in Touch</h2>
    </div>

    <div id="description">
      <p>We are currently available for contract work</p>
    </div>

    <div id="actionable">
      <a
        href={`mailto:${props.email}`}
        target="_top"
        className="btn btn-outline-primary"
      >{props.email}</a>
    </div>
  </section>
);

Contact.defaultProps = {
  email: 'contact@starkissstudios.com',
};

Contact.propTypes = {
  email: PropTypes.string,
};

export default Contact;



// WEBPACK FOOTER //
// ./src/components/contact/index.js